export const iconFontAwesomeArrowsSquareCaretRight = (
	<i className="fa-solid fa-square-caret-right"></i>
);
